<div class="product-list-item-root">
  <div class="general-data">
    <div class="picture">
      <img
        *ngIf="productData.image"
        [alt]="alt"
        [src]="productData.image"
        (error)="handleImageError()"
      />
      <nb-icon *ngIf="!productData.image" icon="printer-outline"></nb-icon>
    </div>
    <div class="name-email">
      <span (click)="openProductInfoModal()" class="name clickable-name">{{
        productData.name
      }}</span>
    </div>
  </div>
  <div class="headers">
    <span *ngFor="let item of productData.headers; let last = last">
      {{ item }}<span *ngIf="!last">; </span>
    </span>
  </div>
  <div class="region-level">
    <span>{{ productData.rewardsQuantity }}</span>
  </div>
  <button class="edit" mat-icon-button (click)="goToProductEdit()">
    <nb-icon icon="edit-outline"></nb-icon>
  </button>
</div>
<div class="product-list-item-divider"></div>
